import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";
import { Input } from "../../atoms/Input";

export interface ToolbarProps extends HTMLAttributes<HTMLDivElement> {
  searchValue?: string;
  onSearchChange?: (v: string) => void;
  placeholder?: string;
  actions?: React.ReactNode;
}

export function Toolbar({
  searchValue,
  onSearchChange,
  placeholder = "Rechercher…",
  actions,
  className,
  ...props
}: ToolbarProps) {
  return (
    <div
      className={cn(
        "mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
      {...props}
    >
      <div className="w-full sm:max-w-xs">
        <Input
          placeholder={placeholder}
          value={searchValue || ""}
          onChange={(e) => onSearchChange?.(e.target.value)}
          aria-label="Rechercher"
        />
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export default Toolbar;
